var id = { exports: {} };
export {
  id as __module
};
//# sourceMappingURL=id.js.map
